import React from 'react';
import WelcomeImage from 'src/assets/galleries-welcome-image.gif';
import { Button, Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import {
  CreateGalleriesWrapperStyled,
  GalleriesEmptyTableStyled,
  WelcomeImageStyled,
  CreateGalleriesSubTitleStyled,
  CreateGalleriesActionButtonsWrapperStyled,
  GalleriesEmptyTableContentStyled,
} from './GalleriesTable.styles';

interface GalleriesEmptyTableProps {
  navigateToCreateGalleryPage: () => void;
}

export const GalleriesEmptyTable = ({
  navigateToCreateGalleryPage,
}: GalleriesEmptyTableProps): JSX.Element => {
  return (
    <GalleriesEmptyTableStyled>
      <GalleriesEmptyTableContentStyled>
        <WelcomeImageStyled src={WelcomeImage} alt='Galleries welcome image' />
        <CreateGalleriesWrapperStyled>
          <Typography variant={TypographyVariant.LargeBold} type={TypographyType.Body}>
            Make inspiration instantly shoppable.
          </Typography>

          <CreateGalleriesSubTitleStyled
            variant={TypographyVariant.MediumRegular}
            type={TypographyType.Paragraph}
          >
            Add hotspots, pick a layout, and use AI to get product suggestions fast.
          </CreateGalleriesSubTitleStyled>
          <CreateGalleriesActionButtonsWrapperStyled>
            <Button onClick={navigateToCreateGalleryPage}>Create Your First Gallery</Button>
          </CreateGalleriesActionButtonsWrapperStyled>
        </CreateGalleriesWrapperStyled>
      </GalleriesEmptyTableContentStyled>
    </GalleriesEmptyTableStyled>
  );
};
